// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./PathTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Path-module__Bar__FVtmD,
.Path-module__SubBar__jv6sR {
    padding: var(--ds-05x) 0;
    background-color: var(--ds-path-bar-background-color);
    border-radius: var(--ds-border-radius-xs);
}

.Path-module__SubBar__jv6sR {
    width: 80%;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Bar": `Path-module__Bar__FVtmD`,
	"SubBar": `Path-module__SubBar__jv6sR`
};
export default ___CSS_LOADER_EXPORT___;
